import React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";

export enum AvailablePosition {
  Absolute = "absolute",
  Inherit = "inherit"
}

export interface PromotionalTagLabelProps {
  color: string;
  text: string;
  position?: AvailablePosition;
}

const PromotionalTagLabel: React.ReactFCWithChildren<PromotionalTagLabelProps> = (({
  color, text, position = AvailablePosition.Absolute
}) => (
  <PromotionalTagLabelWrapper
    position={position}
    backgroundColor={color}
  >
    <Text
      color="white"
      weight="bold"
    >
      {text}
    </Text>
  </PromotionalTagLabelWrapper>
));

const PromotionalTagLabelWrapper = styled.div<{position: AvailablePosition, backgroundColor?: string}>`
${({
    theme, backgroundColor, position
  }) => css`
    position: ${position};
    top: 0;
    left: 0;
    background: ${backgroundColor};
    color: white;
    z-index: 1;
    padding: ${theme.spacing.padding.xs};
    height: 25px;
    min-width: 30px;
    display: flex;
    justify-content: center;
    border-radius: ${position === AvailablePosition.Inherit ? theme.borderRadius : "0"};
    width: fit-content;
  `}
`;

export default PromotionalTagLabel;
